import gql from 'graphql-tag'

export default gql`
	query getCashRegisterLogs($cashRegisterId: ID!, $date: DateTime!, $logsType: CashRegisterLogsType) {
        getCashRegisterLogs(cashRegisterId: $cashRegisterId, date: $date, logsType: $logsType) {
            link
        }
	}
`
